<div style="width: 100%; height: 5%;position: -webkit-sticky;
  position: sticky; top: 0;">
    <button style="float: right;" title="Chiudi" (click)="closeDialog()" mat-icon-button color="warn"
            aria-label="icon-button save">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div [innerHTML]="this.html"></div>
